
  function showATC() {
    // Show the toast
    document.getElementById('atcToast').style.display = 'block';

    // Hide the toast after 3 seconds
    setTimeout(function () {
      document.getElementById('atcToast').style.display = 'none';
    }, 2000); // 3000 milliseconds = 3 seconds
  }
